/**
 * 営業報告時刻の訂正（datetime-local）の入力値を ISO にする
 *
 * datetime-local は年に 6 桁まで入り、「202609-09-30T21:15」は new Date() で Invalid Date になる。
 * 年を 4 桁・2000〜2099 年に絞り、それ以外は null を返す（画面でエラーを出して保存させない）。
 */
export const ACTIVITY_DATE_INPUT_MIN = '2000-01-01T00:00';
export const ACTIVITY_DATE_INPUT_MAX = '2099-12-31T23:59';

const LOCAL_DATETIME = /^(\d{4})-\d{2}-\d{2}T\d{2}:\d{2}$/;

export function parseActivityDateInput(value: string): string | null {
  const match = LOCAL_DATETIME.exec(value);
  if (!match) return null;
  const year = Number(match[1]);
  if (year < 2000 || year > 2099) return null;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date.toISOString();
}
